module.exports = __webpack_public_path__ + "static/media/195-france.00d3ca1d.svg";